import { IChartData, IVideo } from '../../../probability/computes/interfaces';

interface IRoundRecapVideo {
    round: number;
    hole: number;
    video: IVideo;
}

interface IRecapVideo extends IRoundRecapVideo {
    key: number;
}

const getRoundVideos = (
    chartData: IChartData,
    round: number,
): Array<IRoundRecapVideo> => {
    const holes = chartData.xAxis;
    const videos = chartData.videos;

    const items = holes.reduce<Array<IRoundRecapVideo>>((memo, hole) => {
        const video = videos[hole];

        if (!video) {
            return memo;
        }

        memo.push({
            round,
            hole: Number(hole),
            video,
        });

        return memo;
    }, []);

    return items;
};

export const getVideos = (
    chartsData: Array<IChartData>,
): Array<IRecapVideo> => {
    const videos = chartsData.reduce<Array<IRecapVideo>>(
        (memo, item, index) => {
            const roundVideos = getRoundVideos(item, index + 1).map(
                (video, index) => ({
                    key: memo.length + index,
                    ...video,
                }),
            );

            return memo.concat(roundVideos);
        },
        [],
    );

    return videos;
};
